import {BaseModelService} from './BaseModelService';
import {City, State} from '../Models';
import {UriBuilder} from './UriBuilder';

export class StateService extends BaseModelService<State> {
  constructor(apiUrl: string = '') {
    super(State);
    this.apiBaseUrl = `${apiUrl}/v1/misc/states`;
  }

  async findByZip(zip: number): Promise<State> {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('by-zip')
      .path(zip)
      .build();
    const result = await this.restClient.GET(url);
    if (result.response) {
      return new this.modelClass(result.response);
    }
    return this.throwAPIError(result.error);
  }

  async findCities(state: State): Promise<Array<City>> {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path(state.id)
      .path('cities')
      .build();
    const result = await this.restClient.GET(url);
    if (this.hasListResult(result)) {
      return this.getListResult(result).map(
        (instanceData: any) => new City(instanceData),
      );
    }
    return this.throwAPIError(result.error);
  }
}
